// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination__11qva","shellSelectPagination":"Pagination_shellSelectPagination__3z3xq","shellPrevNextButton":"Pagination_shellPrevNextButton__3WuRG"};